// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3zubj","title":"Header_title__2dMcE","side":"Header_side__ni9e9"};